import type { FC, ComponentProps } from 'react';
import classNames from 'classnames';

import { T } from '@web-solutions/module-localization';

import { tKey } from '../../constants'
import { useSpecialOfferTimer } from '../../hooks';

import styles from './style.module.scss';

export const SpecialOfferTimer: FC<ComponentProps<'div'>> = ({ className, ...props }) => {
  const { shown, ended, time } = useSpecialOfferTimer();

  return shown && (
    <div className={classNames(styles.root, className)} {...props}>
      <T
        k={ended ? `${tKey}.timer_end` : `${tKey}.timer_left`}
        tOptions={{ time }}
      />
    </div>
  )
};
